import { AktuelleNachrichtenTabelle } from '../AktuelleNachrichtenTabelle';
import { AktuelleTermineTabelle } from '../AktuelleTermineTabelle';
import { ContextService } from '../../../services/context_service';
import { i18n } from '../../../i18n/i18n';
import { lazyInject } from '../../../services/inversify';
import { Mail } from '../mail/Mail';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

interface KommunikationProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface KommunikationState {
    tabIndex: number;
}

export class Kommunikation extends React.Component<KommunikationProps, KommunikationState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    private disabled: string[] = [];
    private prefix: string = 'admin.tab.kommunikation';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_KOMMUNIKATION;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_KOMMUNIKATION_INFO_MAIL },
        { path: RoutingIDs.ROUTE_KOMMUNIKATION_AKTUELLE_NACHRICHTEN },
        { path: RoutingIDs.ROUTE_KOMMUNIKATION_AKTUELLE_TERMINE }
    ];
    private tabs: string[] = ['info_mail', 'aktuelle_nachrichten', 'aktuelle_nachrichten']; // Reitereihenfolge beachten

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};

        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }

        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-kommunikation'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.info_mail}>{i18n('Info-Mail', 'tab')}</Tab>
                    <Tab disabled={!this.rechte.aktuelle_nachrichten}>{i18n('Aktuelle Nachrichten', 'tab')}</Tab>
                    <Tab disabled={!this.rechte.aktuelle_nachrichten}>{i18n('Aktuelle Termine', 'tab')}</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.info_mail &&
                        <Mail data={this.props.data} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.aktuelle_nachrichten &&
                        <AktuelleNachrichtenTabelle />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.aktuelle_nachrichten &&
                        <AktuelleTermineTabelle />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
